// ------------------------------------------------------------------------------
//  This code is generated by a tool.
//  Manual Changes to this file will be lost.
//  Based on C# type: Euronics.Model.Enums.EditCartFrom
// ------------------------------------------------------------------------------
export enum EditCartFrom {
  HistoryProduct = 0, 
  HistoryAdditionalProduct = 1, 
  HistoryWarranty = 2, 
  ProductDetail = 3, 
  Comparison = 4, 
  SidePanel = 5, 
  ModalAccessory = 6, 
  CartAdditionalProducts = 7, 
  CartCampaignProducts = 8, 
  PanelAdditionalProduct = 9, 
  PanelWarranty = 10, 
  List = 11, 
  SearchList = 12, 
  Cart = 13, 
  CartProductPlusMinus = 14, 
  CartProtectionItem = 15, 
  AddedCartPanel = 16, 
  Favorites = 17, 
  EmailProtectionButton = 18, 
  SD = 19, 
  FrontpageRecentlyViewed = 20, 
  PromotionsPage = 21
}
